import React from "react";

/**
 * Brand — official A4 Assist logo lockup.
 * The logo is designed for light backgrounds (navy A + navy "assist" wordmark).
 * On our dark navy theme we place it on a subtle light "brand plate"
 * for legibility while preserving brand fidelity.
 *
 * size: "sm" (header) | "md" (footer)
 */
export const LOGO_URL = `${process.env.PUBLIC_URL}/assets/a4-assist-logo.webp`;

export default function Brand({ size = "sm", className = "" }) {
  const dims =
    size === "md"
      ? { plate: "h-[60px] w-[150px]", img: "h-full w-full" }
      : { plate: "h-[52px] w-[132px]", img: "h-full w-full" };

  return (
    <span
      className={`inline-flex shrink-0 items-center overflow-hidden ${dims.plate} ${className}`}
      data-testid="brand-logo"
      aria-label="A4 Assist"
    >
      <img
        src={LOGO_URL}
        alt="A4 Assist"
        className={`${dims.img} object-contain object-[center_44%]`}
        loading="eager"
        decoding="async"
      />
    </span>
  );
}
